import { crudMutations, crudActions, attachmentActions, shipmentActions } from './modules/action-helpers'

const basePath = 'api/expedition'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    typeId: 1, // Assuming '1' is the type ID for expeditions
    currentItem: null,
    listQuery: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    ...attachmentActions({ basePath: basePath }),
    ...shipmentActions({ basePath: basePath }),
    async downloadLabel ({ dispatch }, id) {
      return dispatch('downloadFiles', { url: `${basePath}/${id}/download_label` }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async downloadCheck ({ dispatch }, id) {
      return dispatch('downloadFiles', { url: `${basePath}/${id}/download_checklist` }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/expeditions.js